export enum HttpMediasCallPurpose {
    GET_MEDIAS = "getMedias",
    GET_MEDIAS_TAGS = "getMediasTags",
    GET_FEATURED_MEDIAS = "GetFeaturedMedias",
    GET_MEDIAS_BY_CATEGORY = "getMediasByCategory",
    GET_MEDIAS_BY_TAG = "getMediasByTag",
    GET_MEDIAS_BY_COMPANY = "getMediasByCompanyName",
    GET_MEDIAS_BY_SLUG = "getMediasBySlug"
}